$top-offset: 68px;
$desktop-breakpoint: 1024px;

.rightSidebar {
  position: fixed;
  top: $top-offset;
  bottom: 0;
  right: 0;
  z-index: 1003;

  display: none;
  flex-direction: column;
  overflow: hidden;

  width: 64px;
  height: calc(100vh - #{$top-offset});
  height: calc(100dvh - #{$top-offset});

  background: #f8f5f2;
  border-left: 1px solid #e9e9e9;

  transition: width 0.25s ease-in-out;

  &__backdrop {
    position: fixed;
    top: $top-offset;
    left: 0;
    width: 100%;
    height: calc(100dvh - #{$top-offset});
    background: rgba(0, 0, 0, 0.4);
    z-index: 1004;

    @media (min-width: $desktop-breakpoint) {
      display: none;
    }
  }

  &--open {
    display: flex;
    left: auto;
    right: 0;
    width: 280px;
    max-width: 100vw;
    z-index: 1007;
    border-left: 1px solid #e9e9e9;
    box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);

    @media (max-width: 540px) {
      left: 0;
      width: 100vw;
      border-left: 0;
      box-shadow: none;
    }
  }

  @media (min-width: $desktop-breakpoint) {
    display: flex;
    bottom: auto;
    height: calc(100vh - 118px);
    height: calc(100dvh - 118px);

    &--open {
      left: auto;
      right: 0;
      width: min(20vw, 350px);
      max-width: 350px;
      border-left: 1px solid #e9e9e9;
      box-shadow: none;
    }
  }

  @media (min-width: 1025px) {
    &:not(.rightSidebar--open) {
      width: 5vw;
    }
  }

  &__header {
    display: none;
    align-items: center;
    width: 100%;
    height: 48px;
    flex-shrink: 0;
    padding: 0 16px;
    margin: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.15s ease;

    @media (min-width: 1441px) {
      padding: 0 24px;
    }

    &:hover {
      background-color: var(--bg-hover-color);
    }

    svg {
      display: block;
      transition: transform 0.25s ease-in-out;
    }

    &--collapsed {
      padding: 0 16px;

      @media (min-width: 1025px) {
        justify-content: center;
        padding: 0;
      }

      svg {
        transform: rotate(180deg);
      }
    }

    @media (min-width: $desktop-breakpoint) {
      display: flex;
    }
  }

  &__content {
    flex: 1 0 0;
    min-height: 0;
    overflow-y: auto;

    display: flex;
    flex-direction: column;
    gap: 16px;

    padding: 16px;
    border-top: 0;

    @media (min-width: $desktop-breakpoint) {
      border-top: 1px solid #e9e9e9;
    }

    @media (min-width: 1441px) {
      gap: 24px;
      padding: 24px;
    }
  }

  &__titleRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  &__closeButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: none;
    cursor: pointer;
    color: inherit;
    flex-shrink: 0;

    svg {
      display: block;
      width: 16px !important;
      height: 16px !important;
    }

    &:hover {
      background-color: var(--normal-bg, #f0f0f0);
    }

    @media (min-width: $desktop-breakpoint) {
      display: none;
    }
  }

  &__empty {
    margin: 0;
    font-size: 14px;
    color: #5c5c5c;
  }

  &__task {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 12px;

    background: #fff;
    border-radius: 8px;
    font-size: 16px;
    color: #262626;
  }

  &__card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    padding: 16px;

    background: #fff;
    border-radius: 8px;
  }

  &__cardHeader {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__statusTag {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    height: 24px;
    padding: 0 6px;

    background: #0075c2;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    line-height: 21px;
  }

  &__cardLine {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    color: #262626;
  }

  &__cardMeta {
    font-size: 14px;
    color: #5c5c5c;
  }

  &__cardDescription {
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    color: #262626;
  }

  &__cardLink {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}